import { NavigatorMapDTO, PlateWellDTO } from 'business/models/Models';
import { TraversalDirection } from './constants';
import { Plate, WellNavigationDetails } from 'components/Experiment/constants';

export const getWellNavigationDetails = (
  allPlates: Plate[],
  currentWell: WellNavigationDetails,
  step: number,
  traverseDirection: TraversalDirection,
  imagedWells?: PlateWellDTO[],
) => {
  const selectedPlateNum =
    allPlates.findIndex((item) => item.plateId === currentWell.plateID) + 1;

  let nextwellDetails: WellNavigationDetails = {
    wellNum: currentWell.wellNum,
    plateNum: currentWell.plateNum || selectedPlateNum,
    plateID: currentWell.plateID,
  };

  const currentPlate = allPlates[selectedPlateNum - 1];
  const totalWells = allPlates[0].rows * allPlates[0].cols;
  if (traverseDirection === TraversalDirection.Row) {
    if (step > 0) {
      if (currentWell.wellNum !== totalWells) {
        nextwellDetails.wellNum = currentWell.wellNum + 1;
      } else if (selectedPlateNum === allPlates.length) {
        nextwellDetails.plateNum = 1;
        nextwellDetails.wellNum = 1;
      } else {
        nextwellDetails.plateNum += 1;
        nextwellDetails.wellNum = 1;
      }
    } else if (step < 0) {
      if (currentWell.wellNum - 1 === 0) {
        nextwellDetails.wellNum = totalWells;
        if (selectedPlateNum === 1) {
          nextwellDetails.plateNum = allPlates.length;
          nextwellDetails.wellNum = totalWells;
        } else {
          nextwellDetails.plateNum -= 1;
          nextwellDetails.wellNum = totalWells;
        }
      } else {
        nextwellDetails.wellNum = currentWell.wellNum - 1;
      }
    }
  } else if (traverseDirection === TraversalDirection.Column) {
    if (step > 0) {
      if (currentWell.wellNum === totalWells) {
        nextwellDetails.wellNum = 1;
        if (selectedPlateNum === allPlates.length) {
          nextwellDetails.plateNum = 1;
          nextwellDetails.wellNum = 1;
        } else {
          nextwellDetails.plateNum += 1;
          nextwellDetails.wellNum = 1;
        }
      } else if (currentWell.wellNum + currentPlate.cols > totalWells) {
        nextwellDetails.wellNum =
          currentWell.wellNum + currentPlate.cols - totalWells + 1;
      } else {
        nextwellDetails.wellNum = currentWell.wellNum + currentPlate.cols;
      }
    } else if (step < 0) {
      if (currentWell.wellNum === 1) {
        nextwellDetails.wellNum = totalWells;
        if (selectedPlateNum > 1) {
          nextwellDetails.plateNum -= 1;
          nextwellDetails.wellNum = totalWells;
        } else {
          nextwellDetails.plateNum = allPlates.length;
          nextwellDetails.wellNum = totalWells;
        }
      } else if (currentWell.wellNum - currentPlate.cols <= 0) {
        nextwellDetails.wellNum =
          totalWells + (currentWell.wellNum - currentPlate.cols) - 1;
      } else {
        nextwellDetails.wellNum = currentWell.wellNum - currentPlate.cols;
      }
    }
  }
  nextwellDetails.plateID = allPlates[nextwellDetails.plateNum - 1].plateId;
  const isNextWellImaged = imagedWells?.find(
    (item) =>
      item.plateId === nextwellDetails.plateID &&
      item.wellNumber === nextwellDetails.wellNum,
  );
  if (!isNextWellImaged && imagedWells?.length) {
    nextwellDetails = getWellNavigationDetails(
      allPlates,
      nextwellDetails,
      step,
      traverseDirection,
      imagedWells,
    );
  }
  return nextwellDetails;
};

export const getImagedWellsFromNavigatorMap = (
  navigatorMap: NavigatorMapDTO,
  dropNumber: number,
  regionName: string,
  cpIds: number[] = [],
  inspectionIds: number[] = [],
): PlateWellDTO[] => {
  const uniqueWells = [];
  const uniqueWellKeys = new Set();
  if (!navigatorMap) {
    return [];
  }
  navigatorMap.drciList.forEach((item) => {
    if (
      item.drc.dropNumber === dropNumber &&
      item.drc.regionName === regionName &&
      cpIds.includes(item.drc.cpId)
    ) {
      item.inspectedWells.forEach((inspectedWell) => {
        if (inspectionIds.includes(inspectedWell.inspectionId)) {
          inspectedWell.wells.forEach((well) => {
            const wellKey = JSON.stringify(well);
            if (!uniqueWellKeys.has(wellKey)) {
              uniqueWellKeys.add(wellKey);
              uniqueWells.push(well);
            }
          });
        }
      });
    }
  });
  uniqueWells.sort((a, b) => {
    if (a.plateId === b.plateId) {
      return a.wellNumber - b.wellNumber;
    }
    return a.plateId - b.plateId;
  });

  return uniqueWells;
};
